import { PaymentStatus } from "@irati/payments/enums/PaymentV2";
export default function outstandingBalance(paymentOrder, initial) {
    if (initial === void 0) { initial = 0; }
    return paymentOrder.payments.reduce(function (runningTotal, payment) {
        if (payment.status === PaymentStatus.Completed) {
            return runningTotal - payment.amount;
        }
        return runningTotal;
    }, initial);
}
